import { useEffect, useState } from 'react'

export const useDebounce = (
	initialValue = '',
	delay = 300,
): [string, (e: React.ChangeEvent<HTMLInputElement>) => void, string] => {
	const [value, setValue] = useState(initialValue)
	const [debouncedValue, setDebouncedValue] = useState(initialValue)

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value)
		}, delay)
		return () => {
			clearTimeout(handler)
		}
	}, [value, delay])

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setValue(e.target.value)
	}

	return [debouncedValue, handleChange, value]
}
